import { render, staticRenderFns } from "./brightness.vue?vue&type=template&id=6d87c39a&scoped=true&"
import script from "./brightness.js?vue&type=script&lang=js&"
export * from "./brightness.js?vue&type=script&lang=js&"
import style0 from "./brightness-vuetify.css?vue&type=style&index=0&lang=css&"
import style1 from "./brightness.css?vue&type=style&index=1&id=6d87c39a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d87c39a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
